module.exports = new __parcel__URL__("plane_2_blue.df65d8f9.png").toString();